
import MainNavigation from "./components/MainNavigation.vue";
import { defineComponent } from "vue";
import "bootswatch/dist/darkly/bootstrap.min.css";
export default defineComponent({
  components: {
    MainNavigation,
  },
});
